import * as React from 'react';
import {
  DropdownLayoutOption,
  DropdownLayoutValueOption,
} from '../DropdownLayout';
import { ManualInputFnSignature } from '../InputWithOptions';
import { PopoverCommonProps } from '../common';

export interface AddressInputProps {
  dataHook?: string;
  className?: string;
  clearButton?: boolean;
  initialValue?: string;
  value?: string;
  disabled?: boolean;
  onSelect?: (option: DropdownLayoutValueOption) => void;
  onManuallyInput?: ManualInputFnSignature;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onFocus?: (e?: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  autoSelect?: boolean;
  onClear?: () => void;
  options?: DropdownLayoutOption[];
  status?: 'loading' | 'error' | 'warning';
  statusMessage?: React.ReactNode;
  border?: 'standard' | 'round' | 'bottomLine' | 'none';
  size?: 'small' | 'medium' | 'large';
  placeholder?: string;
  noResultsText?: React.ReactNode;
  popoverProps?: PopoverCommonProps;
}

export default class AddressInput extends React.PureComponent<AddressInputProps> {}
